import { render, staticRenderFns } from "./VoidClaimsDetail.vue?vue&type=template&id=1b87c1b4"
import script from "./VoidClaimsDetail.vue?vue&type=script&lang=js"
export * from "./VoidClaimsDetail.vue?vue&type=script&lang=js"
import style0 from "./VoidClaimsDetail.vue?vue&type=style&index=0&id=1b87c1b4&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports